import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import styles from './Login.css';
import { loginAction } from '../../../redux/auth';
import LoginForm from '../../../Components/LoginForm';
import SecondaryButton from '../../../Components/SecondaryButton';
import Button from '../../../Components/Button';
import SITE_MODES from '../../../../constants/site-modes';
import AuthLayoutContainer from '../../../Components/AuthLayoutContainer';

const Login = ({
  login,
  siteMode,
  companyName,
  companyDomain,
  LTIURL,
  location: { search },
}) => {
  const params = queryString.parse(search);
  const normal = 'normal' in params;
  const next = params.next ? `&next=${params.next}` : '';

  const notCurrentStudentButton = () => {
    const skipDomains = ['berry', 'ccu', 'losrios'];
    if (skipDomains.includes(companyDomain)) {
      return null;
    }
    return (
      <div className={styles.footer}>
        <div className={styles.notStudent}>NOT A CURRENT STUDENT?</div>
        <SecondaryButton to={`/login?normal${next}`}>
            LOGIN HERE
        </SecondaryButton>
      </div>
    );
  };

  if (LTIURL && !normal) {
    return (
      <React.Fragment>
        <AuthLayoutContainer className={styles.lticontainer}>
          <h1>{`${companyName} Student Login`}</h1>
          <p>
            {`You’ll need to enter your school login information to access ${
              siteMode === SITE_MODES.EDUCATION
                ? 'PathwayU'
                : 'jobZology'
            }`}
                        .
          </p>
          <Button href={LTIURL}>Login</Button>
        </AuthLayoutContainer>
        {notCurrentStudentButton()}
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <AuthLayoutContainer>
        <LoginForm
          onSubmit={({ userName, password }) =>
            new Promise((resolve, reject) =>
              login({ userName, password, reject, resolve }),
            )
          }
        />
      </AuthLayoutContainer>
      {companyDomain && companyDomain !== 'login' ? (
        <div className={styles.join}>
          <div className={styles.dontHaveAccount}>
                        Don’t have an account yet?
          </div>
          <Link to="/signup">
            <SecondaryButton>join now</SecondaryButton>
          </Link>
        </div>
      ) : null}
    </React.Fragment>
  );
};

Login.propTypes = {
  login: PropTypes.func,
  LTIURL: PropTypes.string,
  location: PropTypes.object,
  siteMode: PropTypes.number,
  companyName: PropTypes.string,
  companyDomain: PropTypes.string,
};

Login.displayName = 'Login';

export default connect(
  ({ theme }) => ({
    LTIURL: theme.LTIURL,
    siteMode: theme.siteMode,
    companyDomain: theme.companyDomain,
    companyName: theme.companyName,
  }),
  {
    login: loginAction,
  },
)(Login);



// WEBPACK FOOTER //
// ./src/client/Pages/Auth/Login/Login.js